import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Groups } from '@app/client';
import { type InviteParam } from '@app/client/common/structs/groups/groups';

import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query useMutation to
 * delete a Member from a Pod.
 */
export function useInviteMember() {
    const queryClient = useQueryClient();

    return useMutation(({ groupId, memberIds }: InviteParam) => Groups.callInviteMember({ groupId, memberIds }), {
        onSuccess: (_data, variables) => {
            /**
             * Invalidate the /groups query to cause a refetch.
             * The`return` will wait for query invalidation to finish.
             * Remove the `return` on the call to fire and forget.
             **/
            return queryClient.invalidateQueries(groupsCacheKeys.invites(variables.groupId));
        },
        onError: (_error: Error, variables) => {
            return queryClient.invalidateQueries(groupsCacheKeys.members(variables.groupId));
        },
    });
}
